import { actionTypes } from '../../constants/actionTypes';
import { IStickBottomState, TReduxActions } from '../../types/redux';

const defaultState = {
  isVisible: false,
};

export function stickBottomReducer(state: IStickBottomState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case actionTypes.SET_VISIBLE_STICK_BOTTOM:
      return {
        isVisible: action.payload,
      };

    default:
      return state;
  }
}
